import { createAction } from 'redux-actions';
// TODO: remove _V2 if/when WatchSuggestions is removed
var actionKey = 'WATCH_SUGGESTIONS_V2';
export var unsuggestUser = createAction(actionKey + ".UNSUGGEST.USER", function (payload) { return payload; });
//# sourceMappingURL=actions.js.map